<div *ngIf="selectedImageData || editable" class="cover">
    <img [src]="selectedImageData" alt="cover" *ngIf="selectedImageData" />
    <button class="add-btn" (click)="uploadFile()" *ngIf="editable">
        <mat-icon>add_a_photo</mat-icon>
    </button>
</div>
